import { PropsWithChildren } from "react";

const EditorSection = ({
  sectionTitle,
  className = '',
  children,
  id,
}: PropsWithChildren<{ sectionTitle: string; className?: string ; id ?:string}>) => (
  <section className={className}>
    <h1 className="mb-5 text-[32px] font-bold text-ctb-blue">{sectionTitle}</h1>
    <div className="flex flex-col gap-7">{children}</div>
  </section>
);

export default EditorSection;
